import { useDispatch, useSelector } from 'react-redux';
import '../css/app.css'
import '../css/common.css'
import { useState, useEffect, useRef, useCallback } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../../store';
import axios from 'axios';
import { MessageModal } from '../component/modal/modal';
import { useNavigate } from 'react-router-dom';

import { CountAmount, CountAmountLeft, CountSelect, DownloadBtn, TotalAmount } from '../component/btn/btn';
import List from '../component/list/list';
import { LoadingModal } from '../component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import { SquareX, SquareCheck, AlertCircle, TrendingUp, Clock, CheckCircle, XCircle, RefreshCw } from 'lucide-react';

import { SearchDate, SearchRange, SearchSelect, SearchSelectText, SearchBtn, SearchCrteateBtn, SearchExcelBtn, SearchInputBtn } from '../component/search/search';
import Select from 'react-select';
import dayjs from 'dayjs';

import { changeNum, convertDateFormat } from '../common/function';

function RiskTrxV2() {
    let dispatch = useDispatch()
    let navigate = useNavigate();

    let MyData = useSelector((state) => { return state.MyData })

    const [page, setPage] = useState(1)
    const [maxFirstPage, setMaxFirstPage] = useState(20)
    const [loading, setLoading] = useState(true)
    const [spinner, setSpinner] = useState(false)

    const [message, setMessage] = useState("")
    const [listData, setListData] = useState([])
    const [listTrxData, setListTrxData] = useState([])
    const [combineData, setCombineData] = useState([])
    const [combineList, setCombineList] = useState([])
    const [reload, setReload] = useState(false)

    
    // 요약 통계
    const [summary, setSummary] = useState({
        total_count: 0,
        pending_count: 0,
        confirmed_count: 0,
        rejected_count: 0,
        total_amount: 0,
        avg_amount: 0,
        max_amount: 0,
        min_amount: 0
    })
    
    // 유형별 통계
    const [byType, setByType] = useState([])

    // 필터 상태
    const [anomalyType, setAnomalyType] = useState("")
    const [userId, setUserId] = useState("")
    const [minAmount, setMinAmount] = useState("")
    const [maxAmount, setMaxAmount] = useState("")
    const [sortBy, setSortBy] = useState("created_at")
    const [sortOrder, setSortOrder] = useState("DESC")
    
    // 컬럼별 필터 상태
    const [columnFilters, setColumnFilters] = useState({
        reviewId: "",
        approvalId: "",
        merchantName: "",
        anomalyType: "",
        amount: "",
        transactionDt: ""
    })
    
    // 활성화된 빠른 필터 추적
    const [activeQuickFilter, setActiveQuickFilter] = useState(null)

    const [listState, setListState] = useState(false)

    // 상세 조회 모달
    const [detailModal, setDetailModal] = useState(false);
    const [detailData, setDetailData] = useState(null);
    const [relatedTransactions, setRelatedTransactions] = useState([]);
    const [memo, setMemo] = useState("");

    // 날짜범위 포맷
    const [preDate, setPreDate] = useState(dayjs().format('YYYY-MM-DD'))
    const [nextDate, setNextDate] = useState(dayjs().format('YYYY-MM-DD'))

    useEffect(() => {
        setDateRange(dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD'))
    }, [])

    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate)
        setNextDate(endDate)
        onSubmitSearch()
    };

    const onSubmitSearch = () => {
        setPage(1)
        setReload(e => !e)
    }

    useEffect(() => {
        dispatch(change_Current_Location("이상거래관리"))
        dispatch(changeHeaderTitle({
            mainTitle: "이상 거래 관리 (V2)"
        }))

        setTimeout(() => {
            setLoading(false)
        }, 500)
    }, [])

    // 요약 통계 조회
    const fetchSummary = useCallback(async () => {
        try {
            await axios.get(process.env.REACT_APP_API + "/api/risk-trx/statistics/summary", {
                withCredentials: true,
                params: {
                    startDate: preDate,
                    endDate: nextDate
                }
            }).then((response) => {
                let tmp = response?.data
                if (tmp?.code < 2000) {
                    setSummary({
                        total_count: tmp?.data?.summary?.total_count || 0,
                        pending_count: tmp?.data?.summary?.pending_count || 0,
                        confirmed_count: tmp?.data?.summary?.confirmed_count || 0,
                        rejected_count: tmp?.data?.summary?.rejected_count || 0,
                        total_amount: tmp?.data?.summary?.total_amount || 0,
                        avg_amount: tmp?.data?.summary?.avg_amount || 0,
                        max_amount: tmp?.data?.summary?.max_amount || 0,
                        min_amount: tmp?.data?.summary?.min_amount || 0
                    })
                    setByType(tmp?.data?.by_type || [])
                }
            })
        } catch (error) {
            console.error(error);
        }
    }, [preDate, nextDate]);

    useEffect(() => {
        fetchSummary()
    }, [fetchSummary, reload])

    useEffect(() => {
        ListData()
    }, [page, preDate, nextDate, anomalyType, userId, minAmount, maxAmount, sortBy, sortOrder, reload])

    const ListData = async () => {
        if (page === 1) setSpinner(true)
        
        const params = {
            page: page,
            limit: maxFirstPage,
            startDate: preDate,
            endDate: nextDate,
            sortBy: sortBy,
            sortOrder: sortOrder,
        };

        if (anomalyType) params.anomalyType = anomalyType;
        if (userId) params.userId = userId;
        if (minAmount) params.minAmount = minAmount;
        if (maxAmount) params.maxAmount = maxAmount;

        await axios.get(process.env.REACT_APP_API + "/api/risk-trx", {
            withCredentials: true,
            params: params
        }).then((response) => {
            let tmp = response?.data
            console.log(tmp)
            if (tmp?.code < 2000) {
                setListData(tmp?.data ?? {})
                if (page === 1) {
                    setListTrxData(tmp?.data?.items ?? []);
                }
                else {
                    setListTrxData((prev) => [...prev, ...tmp?.data?.items ?? []]);
                }
                setListState(e => !e)
            }
            else if (tmp?.code === 9999) {
                setMessage({ msg: "세션이 만료되었습니다." });
            }
            setSpinner(false)
        }).catch(error => {
            console.error(error);
            setMessage({ msg: "데이터 조회에 실패했습니다." });
            setSpinner(false)
        });
    }

    // 상세 조회
    const fetchDetail = async (reviewId) => {
        await axios.get(process.env.REACT_APP_API + `/api/risk-trx/${reviewId}`, {
            withCredentials: true
        }).then((response) => {
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setDetailData(tmp?.data);
                setRelatedTransactions(tmp?.data?.related_transactions || []);
                setMemo(tmp?.data?.memo || "");
                setDetailModal(true);
            } else {
                setMessage({ msg: tmp?.msg || "상세 정보 조회에 실패했습니다." });
            }
        }).catch(error => {
            console.error(error);
            setMessage({ msg: "상세 정보 조회에 실패했습니다." });
        });
    };

    // 메모 업데이트
    const updateMemo = async (reviewId) => {
        await axios.patch(
            process.env.REACT_APP_API + `/api/risk-trx/${reviewId}/memo`,
            { memo: memo },
            { withCredentials: true }
        ).then((response) => {
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setMessage({ msg: "메모가 업데이트되었습니다." });
                fetchDetail(reviewId);
            } else {
                setMessage({ msg: tmp?.msg || "메모 업데이트에 실패했습니다." });
            }
        }).catch((error) => {
            console.error(error);
            setMessage({ msg: "메모 업데이트에 실패했습니다." });
        });
    };

    const onSubmit = async (reviewId, status, memoText = "") => {
        const confirmMsg = status === "CONFIRMED" ? "정상 거래로 확인하시겠습니까?" : "이상 거래로 거부하시겠습니까?";
        if (window.confirm(confirmMsg)) {
            await axios.put(
                process.env.REACT_APP_API + `/api/risk-trx/${reviewId}/status`,
                {
                    review_status: status,
                    memo: memoText,
                    admin_id: MyData?.admin_id,
                },
                {
                    withCredentials: true,
                }
            )
                .then((response) => {
                    let tmp = response?.data;
                    console.log(tmp)
                    if (tmp?.code < 2000) {
                        setMessage({ msg: "상태가 업데이트되었습니다." });
                        fetchSummary(); // 요약 통계 갱신
                        setPage(1)
                        setReload((e) => !e);
                    } else {
                        setMessage({ msg: tmp?.msg || "상태 업데이트에 실패했습니다." });
                    }
                })
                .catch((error) => {
                    console.error(error);
                    setMessage({ msg: "상태 업데이트에 실패했습니다." });
                });
        }
    };

    // 이상 거래 유형별 색상
    const getAnomalyTypeColor = (type) => {
        const colors = {
            'HIGH_VALUE': { bg: '#fef3c7', text: '#92400e', border: '#fbbf24' },
            'DUPLICATE': { bg: '#fee2e2', text: '#991b1b', border: '#f87171' },
            'INSTALLMENT': { bg: '#dbeafe', text: '#1e40af', border: '#60a5fa' },
            'MULTI_TRANSACTION': { bg: '#e9d5ff', text: '#6b21a8', border: '#a78bfa' }
        };
        return colors[type] || { bg: '#f3f4f6', text: '#374151', border: '#9ca3af' };
    };

    const tableHeaderData = [
        { 
            "no": 0, 
            "text": (
                <div style={{ padding: "4px" }}>
                    <input
                        type="text"
                        placeholder="검토ID"
                        value={columnFilters.reviewId}
                        onChange={(e) => setColumnFilters({...columnFilters, reviewId: e.target.value})}
                        onClick={(e) => e.stopPropagation()}
                        className="column-filter-input"
                        style={{
                            width: "100%",
                            height: "24px",
                            padding: "0 4px",
                            fontSize: "11px"
                        }}
                    />
                </div>
            ), 
            "width": "120px", 
            "textAlign": "center" 
        },
        { 
            "no": 1, 
            "text": (
                <div style={{ padding: "4px" }}>
                    <input
                        type="text"
                        placeholder="승인번호"
                        value={columnFilters.approvalId}
                        onChange={(e) => setColumnFilters({...columnFilters, approvalId: e.target.value})}
                        onClick={(e) => e.stopPropagation()}
                        className="column-filter-input"
                        style={{
                            width: "100%",
                            height: "24px",
                            padding: "0 4px",
                            fontSize: "11px"
                        }}
                    />
                </div>
            ), 
            "width": "100px", 
            "textAlign": "center" 
        },
        { 
            "no": 2, 
            "text": (
                <div style={{ padding: "4px" }}>
                    <input
                        type="text"
                        placeholder="가맹점명"
                        value={columnFilters.merchantName}
                        onChange={(e) => setColumnFilters({...columnFilters, merchantName: e.target.value})}
                        onClick={(e) => e.stopPropagation()}
                        className="column-filter-input"
                        style={{
                            width: "100%",
                            height: "24px",
                            padding: "0 4px",
                            fontSize: "11px"
                        }}
                    />
                </div>
            ), 
            "width": "180px", 
            "textAlign": "left" 
        },
        { 
            "no": 3, 
            "text": (
                <div style={{ padding: "4px" }}>
                    <input
                        type="text"
                        placeholder="이상거래 유형"
                        value={columnFilters.anomalyType}
                        onChange={(e) => setColumnFilters({...columnFilters, anomalyType: e.target.value})}
                        onClick={(e) => e.stopPropagation()}
                        className="column-filter-input"
                        style={{
                            width: "100%",
                            height: "24px",
                            padding: "0 4px",
                            fontSize: "11px"
                        }}
                    />
                </div>
            ), 
            "width": "120px", 
            "textAlign": "center" 
        },
        { 
            "no": 4, 
            "text": (
                <div style={{ padding: "4px" }}>
                    <input
                        type="text"
                        placeholder="금액"
                        value={columnFilters.amount}
                        onChange={(e) => setColumnFilters({...columnFilters, amount: e.target.value})}
                        onClick={(e) => e.stopPropagation()}
                        className="column-filter-input"
                        style={{
                            width: "100%",
                            height: "24px",
                            padding: "0 4px",
                            fontSize: "11px"
                        }}
                    />
                </div>
            ), 
            "width": "120px", 
            "textAlign": "right" 
        },
        { 
            "no": 5, 
            "text": (
                <div style={{ padding: "4px" }}>
                    <input
                        type="text"
                        placeholder="거래일시"
                        value={columnFilters.transactionDt}
                        onChange={(e) => setColumnFilters({...columnFilters, transactionDt: e.target.value})}
                        onClick={(e) => e.stopPropagation()}
                        className="column-filter-input"
                        style={{
                            width: "100%",
                            height: "24px",
                            padding: "0 4px",
                            fontSize: "11px"
                        }}
                    />
                </div>
            ), 
            "width": "130px", 
            "textAlign": "center" 
        },
        { 
            "no": 6, 
            "text": "", 
            "width": "auto", 
            "textAlign": "left",
            "skeleton": true
        },
    ]

    // 컬럼별 필터링 함수
    const filterDataByColumns = (data) => {
        if (!data || data.length === 0) return data;
        
        return data.filter((item) => {
            // 검토ID 필터
            if (columnFilters.reviewId && !item.review_id?.toString().includes(columnFilters.reviewId)) {
                return false;
            }
            // 승인번호 필터
            if (columnFilters.approvalId && !item.approval_id?.toString().includes(columnFilters.approvalId)) {
                return false;
            }
            // 가맹점명 필터
            if (columnFilters.merchantName && !(item.merchant_name || item.user_id)?.toString().includes(columnFilters.merchantName)) {
                return false;
            }
            // 이상거래 유형 필터
            if (columnFilters.anomalyType && !(item.anomaly_type_kr || item.anomaly_type)?.toString().includes(columnFilters.anomalyType)) {
                return false;
            }
            // 금액 필터
            if (columnFilters.amount && !changeNum(Number(item.amount))?.toString().includes(columnFilters.amount)) {
                return false;
            }
            // 거래일시 필터
            if (columnFilters.transactionDt && !item.transaction_dt?.toString().includes(columnFilters.transactionDt)) {
                return false;
            }
            return true;
        });
    };

    useEffect(() => {
        let tableBodyData = [];
        let filteredData = filterDataByColumns(listTrxData);
        
        if (filteredData) {
            setCombineList(filteredData)

            for (let i = 0; i < filteredData.length; i++) {
                let data = filteredData[i]
                const typeColor = getAnomalyTypeColor(data.anomaly_type);

                let rowData = [
                    { 
                        "no": 0, 
                        "text": (
                            <span 
                                style={{ cursor: "pointer", color: "#3b82f6", textDecoration: "underline", fontWeight: "600" }}
                                onClick={() => fetchDetail(data.review_id)}
                            >
                                {data.review_id}
                            </span>
                        ), 
                        "width": "120px", 
                        "textAlign": "center" 
                    },
                    { "no": 1, "text": data.approval_id, "width": "100px", "textAlign": "center" },
                    { "no": 2, "text": <span style={{ fontWeight: "500" }}>{data.merchant_name || data.user_id}</span>, "width": "180px", "textAlign": "left" },
                    { 
                        "no": 3, 
                        "text": (
                            <span 
                                style={{ 
                                    padding: "4px 8px", 
                                    borderRadius: "4px", 
                                    fontSize: "11px",
                                    fontWeight: "500",
                                    backgroundColor: typeColor.bg,
                                    color: typeColor.text,
                                    border: `1px solid ${typeColor.border}`
                                }}
                            >
                                {data.anomaly_type_kr || data.anomaly_type}
                            </span>
                        ), 
                        "width": "120px", 
                        "textAlign": "center" 
                    },
                    { 
                        "no": 4, 
                        "text": (
                            <span style={{ fontWeight: "700", color: "#dc2626", fontSize: "13px" }}>
                                {changeNum(Number(data.amount))}원
                            </span>
                        ), 
                        "width": "120px", 
                        "textAlign": "right" 
                    },
                    { "no": 5, "text": data.transaction_dt, "width": "130px", "textAlign": "center" },
                    { 
                        "no": 6, 
                        "text": "", 
                        "width": "auto", 
                        "textAlign": "left",
                        "skeleton": true
                    },
                ]

                rowData.id = data.review_id
                tableBodyData.push(rowData);
            }
            setListState(e => !e)
            setCombineData(tableBodyData)
        }
    }, [listTrxData, page, maxFirstPage, reload, columnFilters])

    const observerRef = useRef(null);
    useEffect(() => {
        if (combineData.length === 0) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && listData.total >= page * maxFirstPage) {
                setPage((prev) => prev + 1);
            }
        });

        if (observerRef.current) {
            observer.observe(observerRef.current);
        }

        return () => {
            if (observerRef.current) {
                observer.unobserve(observerRef.current);
            }
        };
    }, [combineData, listData]);

    const excelBtn = () => {
        setMessage({ msg: "엑셀 다운로드 기능은 준비 중입니다." });
    }

    // 빠른 필터 버튼
    const quickFilters = [
        { label: "고액 (100만원 이상)", value: "HIGH_VALUE", minAmount: 1000000 },
        { label: "오늘 거래", value: "", date: "today" },
        { label: "지난 7일", value: "", date: "7days" },
    ];

    const applyQuickFilter = (filter, index) => {
        // 같은 필터를 다시 클릭하면 해제
        if (activeQuickFilter === index) {
            setActiveQuickFilter(null);
            setAnomalyType('');
            setMinAmount('');
            setMaxAmount('');
            setPreDate(dayjs().format('YYYY-MM-DD'));
            setNextDate(dayjs().format('YYYY-MM-DD'));
            setDateRange(dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD'));
        } else {
            setActiveQuickFilter(index);
            if (filter.value) {
                setAnomalyType(filter.value);
            }
            if (filter.minAmount) {
                setMinAmount(filter.minAmount);
            }
            if (filter.date === "today") {
                const today = dayjs().format('YYYY-MM-DD');
                setPreDate(today);
                setNextDate(today);
                setDateRange(today, today);
            } else if (filter.date === "7days") {
                const today = dayjs();
                const sevenDaysAgo = today.subtract(7, 'day').format('YYYY-MM-DD');
                setPreDate(sevenDaysAgo);
                setNextDate(today.format('YYYY-MM-DD'));
                setDateRange(sevenDaysAgo, today.format('YYYY-MM-DD'));
            }
        }
        setPage(1);
        setReload(e => !e);
    };

    return (
        <div className="content risk-trx-container" id="contents">
            <style>{`
                .column-filter-input {
                    background: #f5f5f5 !important;
                    border: 1px solid #ccc !important;
                }
                .column-filter-input:focus {
                    background: white !important;
                    border: 1px solid #999 !important;
                    outline: none !important;
                }
                .column-filter-input::placeholder {
                    color: #666 !important;
                    font-weight: 500 !important;
                    opacity: 1 !important;
                }
                .column-filter-input::-webkit-input-placeholder {
                    color: #666 !important;
                    font-weight: 500 !important;
                    opacity: 1 !important;
                }
                .column-filter-input::-moz-placeholder {
                    color: #666 !important;
                    font-weight: 500 !important;
                    opacity: 1 !important;
                }
                .column-filter-input:-ms-input-placeholder {
                    color: #666 !important;
                    font-weight: 500 !important;
                    opacity: 1 !important;
                }
            `}</style>
            <style>{`
                /* 1920x920 화면 기준 레이아웃 */
                @media (min-width: 1920px) {
                    .content {
                        max-width: 1920px;
                        margin: 0 auto;
                    }
                    #contents {
                        height: calc(100vh - 80px);
                        max-height: 920px;
                        overflow: hidden;
                        display: flex;
                        flex-direction: column;
                    }
                    .risk-trx-container {
                        display: flex;
                        flex-direction: column;
                        height: 100%;
                        overflow: hidden;
                    }
                    .risk-trx-table-wrapper {
                        flex: 1;
                        min-height: 0;
                        overflow: hidden;
                    }
                }
            `}</style>
            {loading ? <LoadingModal /> : ""}
            <MessageModal message={message} />
            
            {/* 빠른 필터 및 뷰 모드 */}
            <div className="intro-y box p-3 mb-4" style={{ background: "#f9fafb", border: "1px solid #d1d5db" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "10px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                        <span style={{ fontSize: "12px", color: "#666", fontWeight: "500" }}>빠른 필터:</span>
                        {quickFilters.map((filter, idx) => (
                            <button
                                key={idx}
                                style={{
                                    padding: "6px 12px",
                                    fontSize: "12px",
                                    background: activeQuickFilter === idx ? "#3b82f6" : "white",
                                    border: "1px solid #d1d5db",
                                    cursor: "pointer",
                                    color: activeQuickFilter === idx ? "white" : "#333"
                                }}
                                onClick={() => applyQuickFilter(filter, idx)}
                                onMouseOver={(e) => {
                                    if (activeQuickFilter !== idx) {
                                        e.target.style.background = "#f0f0f0"
                                    }
                                }}
                                onMouseOut={(e) => {
                                    if (activeQuickFilter !== idx) {
                                        e.target.style.background = "white"
                                    }
                                }}
                            >
                                {filter.label}
                            </button>
                        ))}
                        <button
                            style={{
                                padding: "6px 12px",
                                fontSize: "12px",
                                background: "white",
                                border: "1px solid #d1d5db",
                                cursor: "pointer",
                                color: "#333"
                            }}
                            onClick={() => {
                                setActiveQuickFilter(null);
                                setAnomalyType('');
                                setUserId('');
                                setMinAmount('');
                                setMaxAmount('');
                                setPreDate(dayjs().format('YYYY-MM-DD'));
                                setNextDate(dayjs().format('YYYY-MM-DD'));
                                setDateRange(dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD'));
                                setPage(1);
                                setReload(e => !e);
                            }}
                            onMouseOver={(e) => e.target.style.background = "#f0f0f0"}
                            onMouseOut={(e) => e.target.style.background = "white"}
                        >
                            초기화
                        </button>
                    </div>
                </div>
            </div>
            

            <div className="intro-y box intro-padding risk-trx-table-wrapper" style={{ background: "white", border: "1px solid #d1d5db", display: "flex", flexDirection: "column", overflow: "hidden" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px", padding: "8px", background: "#f5f5f5", border: "1px solid #d1d5db", fontSize: "12px", flexWrap: "wrap", gap: "12px", flexShrink: 0 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "16px", flexWrap: "wrap" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <span style={{ color: "#666" }}>총 건수:</span>
                            <span style={{ fontWeight: "bold", color: "#333" }}>{changeNum(listData.total || 0)}건</span>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: "16px", flexWrap: "wrap" }}>
                            {byType.map((item, idx) => {
                                const typeNames = {
                                    'HIGH_VALUE': '고액',
                                    'DUPLICATE': '중복',
                                    'INSTALLMENT': '장기할부',
                                    'MULTI_TRANSACTION': '다건'
                                };
                                return (
                                    <div key={idx} style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                        <span style={{ color: "#666", fontSize: "11px" }}>{typeNames[item.anomaly_type] || item.anomaly_type}:</span>
                                        <span style={{ fontWeight: "bold", color: "#333", fontSize: "11px" }}>{changeNum(item.count)}건</span>
                                        <span style={{ color: "#999", fontSize: "10px" }}>({changeNum(Number(item.total_amount))}원)</span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <button
                        onClick={excelBtn}
                        style={{
                            padding: "6px 12px",
                            fontSize: "12px",
                            background: "white",
                            border: "1px solid #999",
                            cursor: "pointer",
                            color: "#333"
                        }}
                        onMouseOver={(e) => e.target.style.background = "#f0f0f0"}
                        onMouseOut={(e) => e.target.style.background = "white"}
                    >
                        엑셀 다운로드
                    </button>
                </div>

                {/* 테이블 뷰 */}
                <div className="div-flex-2 contents" style={{ gap: "20px", flex: 1, minHeight: 0, overflow: "hidden" }}>
                    <div style={{ width: "100%", maxWidth: "100%", height: "100%" }}>
                        <List
                            tableHeaderData={tableHeaderData}
                            tableBodyData={listData?.total ?? 0}
                            filter_tableBodyData={combineData}
                            page={page}
                            setPage={setPage}
                            maxFirstPage={maxFirstPage}
                            listType={true}
                            listState={listState}
                            observerRef={observerRef}
                            nonePage={false}
                            scrollState={true}
                            height={"100%"}
                            spinner={spinner}
                        />
                    </div>
                </div>
            </div>

            {/* 상세 조회 모달 */}
            {detailModal && detailData && (
                <DetailModal
                    detailData={detailData}
                    relatedTransactions={relatedTransactions}
                    memo={memo}
                    setMemo={setMemo}
                    setModal={setDetailModal}
                    updateMemo={updateMemo}
                    onSubmit={onSubmit}
                    MyData={MyData}
                />
            )}
        </div>
    )
}

// 상세 조회 모달 컴포넌트
function DetailModal({ detailData, relatedTransactions, memo, setMemo, setModal, updateMemo, onSubmit, MyData }) {
    return (
        <div id="detail-modal" className="modal show_modal" tabIndex="-1" style={{ display: "block", zIndex: 9999 }}>
            <div className="modal-dialog" style={{ maxWidth: "800px" }}>
                <div className="modal-content marginTop30 modal_sty">
                    <div className="modal-header">
                        <h2 className="font-medium text-base mr-auto">이상 거래 상세 정보</h2>
                        <button
                            className="dropdown-toggle btn px-1 py-1 box modal_btn close_btn_sty"
                            onClick={() => setModal(false)}
                        >
                            <span className="w-4 h-4 flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="12" y1="5" x2="12" y2="19"></line>
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                </svg>
                            </span>
                        </button>
                    </div>
                    <div className="modal-body" style={{ maxHeight: "70vh", overflowY: "auto" }}>
                        <div className="list-info-box">
                            <div className="box-gap">
                                <div className="gap" style={{ borderTop: "1px solid #e1e1e1" }}>
                                    <ul>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "120px" }}>검토 ID</span>
                                                <span className="right-text" style={{ width: "calc(100% - 120px)" }}>{detailData.review_id}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "120px" }}>승인번호</span>
                                                <span className="right-text" style={{ width: "calc(100% - 120px)" }}>{detailData.approval_id}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "120px" }}>가맹점명</span>
                                                <span className="right-text" style={{ width: "calc(100% - 120px)" }}>{detailData.merchant_name || detailData.user_id}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "120px" }}>대표자명</span>
                                                <span className="right-text" style={{ width: "calc(100% - 120px)" }}>{detailData.boss_name || "-"}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "120px" }}>은행</span>
                                                <span className="right-text" style={{ width: "calc(100% - 120px)" }}>{detailData.bank_nm || "-"}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "120px" }}>계좌번호</span>
                                                <span className="right-text" style={{ width: "calc(100% - 120px)" }}>{detailData.accnt_no || "-"}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "120px" }}>계좌명</span>
                                                <span className="right-text" style={{ width: "calc(100% - 120px)" }}>{detailData.accnt_nm || "-"}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "120px" }}>연락처</span>
                                                <span className="right-text" style={{ width: "calc(100% - 120px)" }}>{detailData.merchant_phone || "-"}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "120px" }}>이메일</span>
                                                <span className="right-text" style={{ width: "calc(100% - 120px)" }}>{detailData.merchant_email || "-"}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "120px" }}>거래일시</span>
                                                <span className="right-text" style={{ width: "calc(100% - 120px)" }}>{detailData.transaction_dt}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "120px" }}>금액</span>
                                                <span className="right-text" style={{ width: "calc(100% - 120px)" }}>{changeNum(Number(detailData.amount))}원</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "120px" }}>이상거래 유형</span>
                                                <span className="right-text" style={{ width: "calc(100% - 120px)" }}>{detailData.anomaly_type_kr || detailData.anomaly_type}</span>
                                            </div>
                                        </li>
                                        {detailData.transaction_count && (
                                            <li>
                                                <div className="inner" style={{ width: "100%" }}>
                                                    <span className="left-text" style={{ width: "120px" }}>관련 거래 건수</span>
                                                    <span className="right-text" style={{ width: "calc(100% - 120px)" }}>{detailData.transaction_count}건</span>
                                                </div>
                                            </li>
                                        )}
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "120px" }}>검토 상태</span>
                                                <span className="right-text" style={{ width: "calc(100% - 120px)" }}>
                                                    <span style={{ 
                                                        color: detailData.review_status === "PENDING" ? "#f59e0b" : 
                                                               detailData.review_status === "CONFIRMED" ? "#10b981" : "#ef4444"
                                                    }}>
                                                        {detailData.review_status_kr || detailData.review_status}
                                                    </span>
                                                </span>
                                            </div>
                                        </li>
                                        {detailData.admin_id && (
                                            <li>
                                                <div className="inner" style={{ width: "100%" }}>
                                                    <span className="left-text" style={{ width: "120px" }}>처리 관리자</span>
                                                    <span className="right-text" style={{ width: "calc(100% - 120px)" }}>{detailData.admin_id}</span>
                                                </div>
                                            </li>
                                        )}
                                        {detailData.reviewed_at && (
                                            <li>
                                                <div className="inner" style={{ width: "100%" }}>
                                                    <span className="left-text" style={{ width: "120px" }}>처리 일시</span>
                                                    <span className="right-text" style={{ width: "calc(100% - 120px)" }}>{detailData.reviewed_at}</span>
                                                </div>
                                            </li>
                                        )}
                                        <li>
                                            <div className="inner" style={{ width: "100%", flexDirection: "column", alignItems: "flex-start" }}>
                                                <span className="left-text" style={{ width: "120px", marginBottom: "10px" }}>메모</span>
                                                <textarea
                                                    className="form-control"
                                                    rows="3"
                                                    value={memo}
                                                    onChange={(e) => setMemo(e.target.value)}
                                                    placeholder="메모를 입력하세요"
                                                    style={{ width: "100%", fontSize: "12px" }}
                                                />
                                                <button
                                                    className="btn btn-primary mt-2"
                                                    onClick={() => updateMemo(detailData.review_id)}
                                                >
                                                    메모 저장
                                                </button>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        {/* 중복 거래 관련 거래 목록 */}
                        {relatedTransactions.length > 0 && (
                            <div className="mt-4">
                                <h4 className="font-medium mb-3">관련 거래 목록</h4>
                                <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                                    <table className="table table-bordered" style={{ fontSize: "12px" }}>
                                        <thead>
                                            <tr>
                                                <th>거래ID</th>
                                                <th>거래일시</th>
                                                <th>금액</th>
                                                <th>승인번호</th>
                                                <th>구매자명</th>
                                                <th>카드번호</th>
                                                <th>상태</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {relatedTransactions.map((trx, index) => (
                                                <tr key={index}>
                                                    <td>{trx.id}</td>
                                                    <td>{trx.trx_date}</td>
                                                    <td>{changeNum(Number(trx.amt))}원</td>
                                                    <td>{trx.approval_id}</td>
                                                    <td>{trx.buyer_nm || "-"}</td>
                                                    <td>{trx.card_num || "-"}</td>
                                                    <td>{trx.state === "1" ? "정상" : "취소"}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}

                        {/* 상태 변경 버튼 (대기중인 경우만) */}
                        {detailData.review_status === "PENDING" && (
                            <div className="mt-4 flex gap-2 justify-end">
                                <button
                                    className="btn btn-success"
                                    onClick={() => {
                                        onSubmit(detailData.review_id, "CONFIRMED");
                                        setModal(false);
                                    }}
                                >
                                    <SquareCheck width={15} height={15} style={{ marginRight: "5px" }} />
                                    확인
                                </button>
                                <button
                                    className="btn btn-danger"
                                    onClick={() => {
                                        onSubmit(detailData.review_id, "REJECTED");
                                        setModal(false);
                                    }}
                                >
                                    <SquareX width={15} height={15} style={{ marginRight: "5px" }} />
                                    거부
                                </button>
                            </div>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={() => setModal(false)}
                        >
                            닫기
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RiskTrxV2;
